import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { getPaginationPayload } from '~/utils/pagination';
import { IAuditLogsStore, IThunkGetMoreAuditLogs } from '../types';

const onGetMoreAuditLogs: IThunkGetMoreAuditLogs = thunk(
  // @ts-ignore
  async ({ setMoreAuditLogs }, filters, { getState }) => {
    const localState = getState() as IAuditLogsStore;

    const paginationPayload = getPaginationPayload(localState.pagination);

    const { data } = await api.auditLogs.getList({
      ...filters,
      ...paginationPayload,
    });

    setMoreAuditLogs(data);
  },
);

export default onGetMoreAuditLogs;
